
export class Revision {
code: string;
kind: string;
revisionNumber: number | null;
scope: string;
vision: string;
}

